// Managed Kubernetes (Wolf) self-serve activation constants.
// Provider name drives the catalog look-up in KubernetesActivateLanding, which
// POSTs /api/v3/services with the resolved provider id.

/** Provider codename that backs a first-time Managed Kubernetes activation. */
export const KUBERNETES_PROVIDER = 'wolf';

/** Route to a Kubernetes service console. */
export function kubernetesConsoleRoute(serviceId: string): string {
  return `/services/kubernetes/${serviceId}`;
}

/** Card metadata for the Managed Kubernetes product (activation dialog copy). */
export const KUBERNETES_PRODUCT = {
  displayName: 'Managed Kubernetes',
  /** Full product name used as the created service's name on self-serve activation. */
  serviceName: 'Managed Kubernetes',
  description:
    'Managed Kubernetes — provision clusters with node pools, ingress and auto-scaling on the Techev Cloud platform.',
  features: ['Clusters', 'Node Pools', 'Ingress', 'Auto-scaling'],
} as const;
